import { DeepPartial } from '@utils/deep-partial'
import { api } from '@services/api'
import { PasswordChangeProps, User } from './types'
export * from './types'

export const show = (id: number) => {
  return api.get<User>(`/users/${id}`)
}

export const password = (id: number, body: PasswordChangeProps) =>
  api.put<{ message: string }>(`/users/password_update/${id}`, {
    user: {
      userId: id,
      ...body
    }
  })

export const update = (
  id: number,
  body: DeepPartial<Omit<User, 'roles' | 'id'>>
) => api.put<{ message: string }>(`/users/${id}`, body)

export const patch = (
  id: number,
  body: DeepPartial<Omit<User, 'roles' | 'id'>>
) => api.patch<{ message: string }>(`/users/${id}`, body)

export const UsersApi = {
  show,
  password,
  update,
  patch
}
